var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2266)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2266",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0903 0H0V15.0903H15.0903V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43192 14.3043H5.65934C2.88649 14.3043 2.04395 13.4618 2.04395 10.6889V4.40128C2.04395 1.62843 2.88649 0.785889 5.65934 0.785889H9.43192C12.2048 0.785889 13.0473 1.62843 13.0473 4.40128V10.6889C13.0473 13.4618 12.2048 14.3043 9.43192 14.3043ZM5.65934 1.72903C3.40836 1.72903 2.98709 2.15659 2.98709 4.40128V10.6889C2.98709 12.9336 3.40836 13.3612 5.65934 13.3612H9.43192C11.6829 13.3612 12.1042 12.9336 12.1042 10.6889V4.40128C12.1042 2.15659 11.6829 1.72903 9.43192 1.72903H5.65934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80303 3.92972H6.28798C6.03019 3.92972 5.81641 3.71594 5.81641 3.45815C5.81641 3.20035 6.03019 2.98657 6.28798 2.98657H8.80303C9.06083 2.98657 9.27461 3.20035 9.27461 3.45815C9.27461 3.71594 9.06083 3.92972 8.80303 3.92972Z",
    fill: "url(#paint0_linear_18_2266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5458 12.487C6.74727 12.487 6.09961 11.8394 6.09961 11.0409C6.09961 10.2424 6.74727 9.59473 7.5458 9.59473C8.34433 9.59473 8.99195 10.2424 8.99195 11.0409C8.99195 11.8394 8.34433 12.487 7.5458 12.487ZM7.5458 10.5316C7.26914 10.5316 7.04279 10.7579 7.04279 11.0346C7.04279 11.3113 7.26914 11.5376 7.5458 11.5376C7.82245 11.5376 8.04881 11.3113 8.04881 11.0346C8.04881 10.7579 7.82245 10.5316 7.5458 10.5316Z",
    fill: "url(#paint1_linear_18_2266)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2266",
    x1: 7.54551,
    y1: 2.98657,
    x2: 7.54551,
    y2: 3.92972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6D4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2266",
    x1: 7.54578,
    y1: 9.59473,
    x2: 7.54578,
    y2: 12.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6D4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0903,
    height: 15.0903,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxMobile);
export default __webpack_public_path__ + "static/media/iconsax-mobile.0a80e9bc7703fa63dbf8a63ed14700e7.svg";
export { ForwardRef as ReactComponent };